import { DEFAULT_ROLE_TOKEN_HEADER } from "@hg/one-account"

import { auth } from "@/utils/auth"
import request from "@/utils/request"

export type RESP<T = null> = {
    statusCode?: number
    code: number
    msg?: string
    data: T
}

export interface Account {
    channelId: 1 | 2
    uid: string
    nickName: string
}

export async function loginYostar(
    email: string,
    code: string
): Promise<{
    code: any
    data: any
    msg: any
}> {
    return request({
        url: `/api/account/login`,
        method: "post",
        data: {
            email,
            code,
        },
    })
}

export async function sendSmsCode(email:string): Promise<{
    code: any
    data: any
    msg: any
}> {
    return request({
        url: `/api/account/send`,
        method: 'post', 
        data: {
            email
        },
    })
}

export async function logout(): Promise<{
    code: number
    msg: string
}> {
    return request.post(`/api/account/logout`, {})
}

export const login = async (token: string) => {
    return request.post<null, RESP<null>>("login", {
        token,
    })
}

// export const getUserInfo = async (token?: string) => {
//     return request.get<null, RESP<Account>>("info", {
//         headers: {
//             [DEFAULT_ROLE_TOKEN_HEADER]: token,
//         },
//     })
// }

export async function getUserInfo(): Promise<{
    msg: any
    data: any
    code: any
}> {
    return request({
        url: `/api/account/info?times=${Date.now()}`,
        method: "get",
    })
}

export function getServerSummary<T>(topicId: string): Promise<{
    code: number
    data: T
    msg: string
}> {
    return request.get(`/api/topic/${topicId}/serverSummary`, {
        headers: {
            [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
        },
    })
}

export function getPlayerSummary<T>(topicId: string): Promise<{
    code: number
    data: T
    msg: string
}> {
    return request.get(`/api/topic/${topicId}/playerSummary`, {
        headers: {
            [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
        },
    })
}
